import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Button, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ResultGrid } from '../../../grid/ResultGrid';
import { Column } from '../../../grid/Column';
import { DeleteIcon } from '../../../icon/DeleteIcon';
import { EditIcon } from '../../../icon/EditIcon';
import { InfoIcon } from '../../../icon/InfoIcon';
import { RawHtml } from '../../../form/RawHtml';
import {
  minColumns,
  sort as defaultSort,
  visibleColumns as defaultColumns,
} from '../../../../redux/references/data/referenceReduxConstants';
import {
  bulkEditReferences as bulkEditReferencesAc,
  cancelEdit as cancelEditAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
  openEditConfirmation as openEditConfirmationAc,
  startEdit as startEditAc,
} from '../../../../redux/references/data/referenceDataActions';
import { createInitialForm, formToJson } from '../edit/referenceEditModel';
import { checkboxCell, textCell } from '../../../grid/resultGridCells';

const renderEditLink = id => (
  <Link aria-label={`Edit Reference ${id}`} to={`/view/reference/update/${id}`} target="_blank" rel="noopener noreferrer">
    <EditIcon />
  </Link>
);

const renderInfoLink = id => (
  <Link aria-label={`Reference Info ${id}`} to={`/view/reference/info/${id}`}>
    <InfoIcon />
  </Link>
);

const handleBeforeUnload = (event) => {
  event.preventDefault();
  // eslint-disable-next-line no-param-reassign
  event.returnValue = 'leaving reference';
};

export class ReferenceDataGridUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.focus = this.focus.bind(this);
    this.handleYesClick = this.handleYesClick.bind(this);
    this.renderModal = this.renderModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditToggle = this.handleEditToggle.bind(this);
    this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.deleteCancel = null;
    this.state = {
      modal: false,
      selectedId: null,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      deleting,
      onDeleteCloseModal,
      saving,
      cancelEditConfirmation,
      errors,
      cancelEdit,
    } = this.props;

    if (!deleting && prevProps.deleting) {
      this.closeModal(() => {
        onDeleteCloseModal();
      });
    }
    if (!saving && prevProps.saving) {
      cancelEditConfirmation();
      window.removeEventListener('beforeunload', handleBeforeUnload, true);
      if (!errors.size) {
        cancelEdit();
        onDeleteCloseModal(); // reload
      }
    }
  }

  openModal(selectedId) {
    this.setState({
      modal: true,
      selectedId,
    });
  }

  closeModal(callback) {
    this.setState({
      modal: false,
      selectedId: null,
    }, callback);
  }

  handleDeleteClick(id) {
    this.openModal(id);
  }

  focus() {
    this.deleteCancel.focus();
  }

  handleYesClick() {
    const { deleteReference } = this.props;
    const { selectedId } = this.state;
    deleteReference({ id: selectedId });
  }

  renderModal() {
    const {
      deleting,
      saving,
    } = this.props;

    const { modal } = this.state;

    if (saving) {
      return (
        <Modal isOpen={modal} onOpened={this.focus} backdrop="static">
          <ModalBody>Saving...</ModalBody>
        </Modal>
      );
    }

    return (
      <Modal isOpen={modal || deleting} onOpened={this.focus} backdrop="static">
        <ModalHeader>Delete Tsunami Event</ModalHeader>
        <ModalBody>
          {deleting ? 'Deleting...' : 'Are you sure you want to delete the tsunami event?'}
        </ModalBody>
        <ModalFooter>
          <Button disabled={deleting} color="danger" onClick={this.handleYesClick}>Delete</Button>
          {' '}
          <Button disabled={deleting} color="secondary" innerRef={(ref) => { this.deleteCancel = ref; }} onClick={() => this.closeModal()}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }

  handleToggleColumns({ visibleColumns, sort }) {
    const {
      visibleColumns: preVisibleColumns, sort: prevSort, sortData, toggleColumns,
    } = this.props;
    let changed = false;
    if (!visibleColumns.sort().equals(preVisibleColumns.sort())) {
      toggleColumns(visibleColumns);
      changed = true;
    }
    if (!sort.equals(prevSort)) {
      sortData(sort);
      changed = true;
    }
    return changed;
  }

  handleSubmit(data) {
    const { bulkEditReferences } = this.props;
    bulkEditReferences({ data });
  }

  handleEditToggle(edit) {
    const { startEdit, cancelEdit, references } = this.props;
    if (edit) {
      const items = {};
      const initialValues = { items };
      references.forEach((item) => {
        items[`${item.get('id')}`] = createInitialForm(item).toJS();
      });
      startEdit({ initialValues });
      window.addEventListener('beforeunload', handleBeforeUnload, true);
    } else {
      cancelEdit();
      window.removeEventListener('beforeunload', handleBeforeUnload, true);
    }
  }

  render() {
    const {
      references,
      dataManager,
      visibleColumns,
      sort,
      searchParams,
      deleting,
      editConfirmationOpen,
      saving,
      formData,
      cancelEditConfirmation,
      openEditConfirmation,
      initialFormData,
      initialValues,
      editing,
      errors,
    } = this.props;

    const { modal } = this.state;

    return (
      <div className="haz-data-grid-container">

        { dataManager && (
        <Modal isOpen={modal || deleting} onOpened={this.focus} backdrop="static">
          <ModalHeader>Delete Reference</ModalHeader>
          <ModalBody>
            {deleting ? 'Deleting...' : 'Are you sure you want to delete the reference?'}
          </ModalBody>
          <ModalFooter>
            <Button disabled={deleting} color="danger" onClick={this.handleYesClick}>Delete</Button>
            {' '}
            <Button disabled={deleting} color="secondary" innerRef={(ref) => { this.deleteCancel = ref; }} onClick={() => this.closeModal()}>Cancel</Button>
          </ModalFooter>
        </Modal>
        )}

        <ResultGrid
          data={references}
          sort={sort}
          handleColumnsToggle={this.handleToggleColumns}
          visibleColumns={visibleColumns}
          columnChooser
          download
          downloadPrefix="references"
          downloadSearchParams={searchParams}
          defaultColumns={defaultColumns}
          defaultSort={defaultSort}
          minColumns={minColumns}
          edit={dataManager}
          editing={editing}
          handleEditToggle={this.handleEditToggle}
          handleSubmit={this.handleSubmit}
          initialValues={initialValues}
          editConfirmationOpen={editConfirmationOpen}
          saving={saving}
          handleCancel={cancelEditConfirmation}
          formData={formData}
          initialFormData={initialFormData}
          openEditConfirmation={openEditConfirmation}
          formToJson={formToJson}
        >
          { dataManager && (
          <Column id="del" alwaysVisible downloadable={false} cell={({ row }) => (<DeleteIcon handleClick={() => this.handleDeleteClick(row.get('id'))} />)} width={30}>
            <DeleteIcon />
          </Column>
          )}
          { dataManager && (
          <Column id="edit" alwaysVisible downloadable={false} cell={({ row }) => renderEditLink(row.get('id'))} width={30}>
            <EditIcon />
          </Column>
          )}
          <Column id="id" width={50} alwaysVisible sortable>Id</Column>
          { dataManager && (
          // <Column id="publish" cell={({ value }) => (value ? 'Y' : 'N')} width={45} alwaysVisible sortable>Publish</Column>
            <Column alwaysVisiblesortable id="publish" cell={({ value, row }) => checkboxCell(row, 'publish', value, errors, editing)} width={45} sortable>Publish</Column>
          )}
          { dataManager && (<Column id="moreInfo" downloadable={false} width={60} cell={({ row }) => renderInfoLink(row.get('id'))}>More Info</Column>)}
          <Column id="author" width={300} sortable cell={({ value, row }) => textCell(row, 'author', value, errors, editing)}>Author</Column>
          <Column id="year" width={80} sortable cell={({ value, row }) => textCell(row, 'year', value, errors, editing)}>Year</Column>
          <Column id="citation" width={800} sortable cell={({ value, row }) => textCell(row, 'citation', (<RawHtml>{value}</RawHtml>), errors, editing)}>Citation</Column>
          { dataManager && (<Column id="ok" width={30} sortable cell={({ value, row }) => textCell(row, 'ok', value, errors, editing)}>Ok</Column>)}
          { dataManager && (<Column id="have" width={35} sortable cell={({ value, row }) => textCell(row, 'have', value, errors, editing)}>Have</Column>)}
          { dataManager && (<Column id="comments" width={300} sortable cell={({ value, row }) => textCell(row, 'comments', value, errors, editing)}>Comments</Column>)}
        </ResultGrid>
      </div>
    );
  }
}

ReferenceDataGridUnwrapped.propTypes = {
  references: ImmutablePropTypes.list.isRequired,
  dataManager: PropTypes.bool.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  searchParams: PropTypes.string.isRequired,
  deleting: PropTypes.bool.isRequired,
  deleteReference: PropTypes.func.isRequired,
  onDeleteCloseModal: PropTypes.func.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
  sortData: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  bulkEditReferences: PropTypes.func.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  initialFormData: ImmutablePropTypes.map.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  errors: ImmutablePropTypes.map.isRequired,
  startEdit: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired,
  initialValues: ImmutablePropTypes.map.isRequired,
};

const mapStateToProps = state => ({
  saving: state.getIn(['referenceDataPage', 'saving']),
  editConfirmationOpen: state.getIn(['referenceDataPage', 'editConfirmationOpen']),
  formData: state.getIn(['referenceDataPage', 'formData']),
  initialFormData: state.getIn(['referenceDataPage', 'initialFormData']),
  errors: state.getIn(['referenceDataPage', 'errors']),
  editing: state.getIn(['referenceDataPage', 'editing']),
  initialValues: state.getIn(['referenceDataPage', 'initialValues']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  bulkEditReferences: bulkEditReferencesAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
  startEdit: startEditAc,
  cancelEdit: cancelEditAc,
}, dispatch);

export const ReferenceDataGrid = connect(mapStateToProps, mapDispatchToProps)(ReferenceDataGridUnwrapped);
